export default {"src":"https://fishbrain.com/_next/static/media/ic_weather_night_122.9ab05b23.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};